import React from 'react';
import { Link } from 'react-router-dom';

const formatPrice = (price) => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0
  }).format(price);
};

export const ProductCard = ({ product }) => {
  return (
    <Link 
      to={`/productos/${product.slug}`}
      className="product-card group block"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="aspect-3-2 overflow-hidden">
        <img
          src={product.image_url}
          alt={`Producto: ${product.name}`}
          className="w-full h-full object-cover product-image"
          loading="lazy"
          decoding="async"
          width="400"
          height="267"
        />
      </div>
      <div className="p-4 md:p-6">
        <h3 className="font-heading text-base md:text-lg text-[#1E1E1E] mb-1">
          {product.name}
        </h3>
        {product.price && (
          <p className="font-heading text-lg text-[#7A5A2E] mb-2">
            {formatPrice(product.price)}
          </p>
        )}
        <p className="font-body text-sm text-[#4E3A21] opacity-80 mb-4 line-clamp-2">
          {product.short_desc}
        </p>
        <span className="font-body text-sm text-[#7A5A2E] group-hover:text-[#4E3A21] transition-colors">
          Ver detalle →
        </span>
      </div>
    </Link>
  );
};

export default ProductCard;
